import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

import { AlertLineData } from './../alert-line/alert-line-data';
import { ConnectedPage } from './../root_classes/connected-page';
import { ConstantsModule } from './../constants/constants.module';

@Component({
	selector: 'app-my-password',
	templateUrl: './my-password.component.html',
	styleUrls: ['./my-password.component.scss']
})
export class MyPasswordComponent extends ConnectedPage implements OnInit {

	public alertLineData: AlertLineData = new AlertLineData();

	public password1: string = "";
	public password2: string = "";

	constructor(constantsModule: ConstantsModule, cookieService: CookieService, httpClient: HttpClient, router: Router, modalService: NgbModal) {
		super(constantsModule, cookieService, httpClient, router, modalService);
	}

	ngOnInit(): void {
	}

	public doSave(): void {
		// Vérirication que le mot de passe n'est pas vide.
		if (this.password1 == "") {
			this.alertLineData.alertDangerMessage = "Merci de saisir un nouveau mot de passe.";
			return;
		}

		// Verification que le mot de passe est le même.
		if (this.password1 != this.password2) {
			this.alertLineData.alertDangerMessage = "Attention, vous n'avez pas saisi deux fois le même mot de passe.";
			return;
		}

		// Enregistrement.
		var newPass = { pass: this.password1 };
		this.put("/api/user-change-password", newPass,
			(data) => {
				if (data.DATA == "OK") {
					this.alertLineData.alertSuccessMessage = "Mot de passe modifié.";
					return;
				}

				this.alertLineData.alertDangerMessage = "Impossible de modifier votre mot de passe. Merci de contacter votre administrateur.";
				return;
			},
			(err) => {
				this.alertLineData.alertDangerMessage = "Impossible de modifier votre mot de passe. Merci de contacter votre administrateur.";
				return;
			}
		);
	}

}
